import React from "react";
import styles from "../ritualpraxis.module.css";
import Head from "next/head";

export default function Main_page() {
  return (
    <>
      <Head>
        <title>Ritual Praxis and Instructions | School of Our Divine Infinite Being</title>
      </Head>
      <div className={styles.ritual_praxis_page_part1_main}>
        <div className={styles.blck_sec_common_width}>
          <div className={styles.common_width}>
            <div className={styles.orange_heading_section}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>RITUAL PRAXIS AND INSTRUCTIONS</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.content_section_main} style={{ width: '100%', marginTop: '20px' }}>
            <div className={styles.content_section}>
              <p style={{ textAlign: 'center', fontSize: '24px' }}>
                Welcome to the sacred instructions of Ritual Praxis. Use the navigation buttons to explore the chapters.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
